module.exports = __webpack_public_path__ + "static/media/Powered_by_Stripe_-_blurple.47cc6a78.svg";